/* eslint-disable eqeqeq */
import { useState, useEffect, useCallback } from "react";
import { useSelector } from "react-redux";
import useMediaQuery from "@mui/material/useMediaQuery";
import moment from "moment";
import CloseIcon from "@mui/icons-material/Close";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
// common_groupstructure_GETROW
import Grid from "@mui/material/Grid";
import WmsHead from "./processComponent/WmsHead";
import "./PoCostCompareReport.css";
import { CmpButton } from "../../Component/Common/ToolBox/ToolBox";
import GCWebReport from "../../Component/Common/ReuseableComponent/GCWebReport";

import {
  ReportTitle,
  ReportRemoveSequenceChar,
  ReportUrl,
} from "../../Utility/Utilitys";

import {
  HeadObjectInit,
  sWebStockReportData,
  sWebStockReportArr,
  fWmsStockRepotArr,
  fWmsStockRepotBrandArr,
  GetWmsStockRepotBrand,
  GetLocation,
  GetBuyer,
  GetWmsStockRepotMainSupplier,
  GetItemFullSearchArr,
  GetSearchItem,
  fValidationHead_Client,
  sWebBetweenReportArr,
} from "./PoCostCompareReportAction";

// import { set } from 'date-fns/esm';

export default function PoCostCompareReport() {
  const vMediaQuery = useMediaQuery("(max-width:450px)");

  //Head
  const [HeadObject, setHeadObject] = useState(HeadObjectInit);

  const [sLocationData, setLocationData] = useState([
    // { Uid: "Distribution", Value: "Distribution" },
  ]);
  const [sBuyerData, setBuyerData] = useState([
    // { Uid: "Distribution", Value: "Distribution" },
  ]);

  const [sMainGroupData, setMainGroupData] = useState([
    // {
    //   Cd: "01",
    //   Name1: "FMCG FOOD",
    // },
  ]);

  const [sSubGroupData, setSubGroupData] = useState([
    // {
    //   Cd: "01",
    //   Name1: "FMCG FOOD",
    // },
  ]);

  const [sCategoryData, setCategoryData] = useState([
    // {
    //   Cd: "01",
    //   Name1: "FMCG FOOD",
    // },
  ]);

  const [sBrandData, setBrandData] = useState([]);
  const [sBrandCategoryData, setBrandCategoryData] = useState([]);

  const [sMainSupplierData, setMainSupplierData] = useState([]);

  //Head

  const fLocation = async (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sLocation: e.target.value,
      sLocationArr: [],
      sLocationPrnt: "",
      sLocationName: "",
    }));
  };

  const fLocation_MultiSelect = async (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");

    setHeadObject((obj) => ({
      ...obj,
      sLocationArr: value,
      sLocationPrnt: value?.length <= 0 ? "" : currentPrnt,
      sLocationName: value?.length <= 0 ? "" : currentName,
    }));
  };
  const fBuyer = async (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sBuyer: e.target.value,
      sBuyerArr: [],
      sBuyerPrnt: "",
      sBuyerName: "",
    }));
  };

  const fBuyer_MultiSelect = async (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");

    setHeadObject((obj) => ({
      ...obj,
      sBuyerArr: value,
      sBuyerPrnt: value?.length <= 0 ? "" : currentPrnt,
      sBuyerName: value?.length <= 0 ? "" : currentName,
    }));
  };

  const fMainGroup = async (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sMainGroup: e.target.value,
      sMainGroupArr: [],
      sMainGroupPrnt: "",
      sMainGroupName: "",
      sSubGroup: "All",
      sSubGroupArr: [],
      sSubGroupPrnt: "",
      sSubGroupName: "",
      sCategory: "All",
      sCategoryArr: [],
      sCategoryPrnt: "",
      sCategoryName: "",
    }));
    setSubGroupData([]);
    setCategoryData([]);

    if (e.target.value.toUpperCase() == "ALL") {
      setMainGroupData([]);
    } else if (e.target.value.toUpperCase() == "IS") {
      let xGroupStructureObj = {
        Prnt: "",
        Lvl: "1",
      };
      await fWmsStockRepotArr(xGroupStructureObj, setMainGroupData);
    }
  };

  const fMainGroup_MultiSelect = async (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");

    setHeadObject((obj) => ({
      ...obj,
      sMainGroupArr: value,
      sMainGroupPrnt: value?.length <= 0 ? "" : currentPrnt,
      sMainGroupName: value?.length <= 0 ? "" : currentName,
    }));
    fMainGroup_Focus();
  };
  const fMainGroup_Focus = (value) => {
    setHeadObject((obj) => ({
      ...obj,
      sSubGroup: "All",
      sSubGroupArr: [],
      sSubGroupPrnt: "",
      sSubGroupName: "",
      sCategory: "All",
      sCategoryArr: [],
      sCategoryPrnt: "",
      sCategoryName: "",
    }));
    setSubGroupData([]);
    setCategoryData([]);
  };

  const fSubGroup = async (e) => {
    setHeadObject((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
      sSubGroupArr: [],
      sSubGroupPrnt: "",
      sSubGroupName: "",
      sCategory: "All",
      sCategoryArr: [],
      sCategoryPrnt: "",
      sCategoryName: "",
    }));

    setCategoryData([]);
    if (e.target.value.toUpperCase() == "ALL") {
      setSubGroupData([]);
    } else if (e.target.value.toUpperCase() == "IS") {
      let xGroupStructureObj2 = {
        Prnt: HeadObject.sMainGroupPrnt,
        Lvl: "2",
      };
      await fWmsStockRepotArr(xGroupStructureObj2, setSubGroupData);
    }
  };

  const fSubGroup_MultiSelect = (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sSubGroupArr: value,
      sSubGroupPrnt: value?.length <= 0 ? "" : currentPrnt,
      sSubGroupName: value?.length <= 0 ? "" : currentName,
    }));
    fSubGroup_Focus();
  };

  const fSubGroup_Focus = (value) => {
    setHeadObject((obj) => ({
      ...obj,
      sCategory: "All",
      sCategoryArr: [],
      sCategoryPrnt: "",
      sCategoryName: "",
    }));
    setCategoryData([]);
  };

  const fCategory = async (e) => {
    setHeadObject((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
      sCategoryArr: [],
      sCategoryPrnt: "",
      sCategoryName: "",
    }));

    if (e.target.value.toUpperCase() == "ALL") {
      setCategoryData([]);
    } else if (e.target.value.toUpperCase() == "IS") {
      let xGroupStructureObj2 = {
        Prnt: HeadObject.sSubGroupPrnt,
        Lvl: "3",
      };

      await fWmsStockRepotArr(xGroupStructureObj2, setCategoryData);
    }
  };

  const fCategory_MultiSelect = (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sCategoryArr: value,
      sCategoryPrnt: value?.length <= 0 ? "" : currentPrnt,
      sCategoryName: value?.length <= 0 ? "" : currentName,
    }));
    fCategory_Focus();
  };
  const fCategory_Focus = (value) => {};

  const fBrand = async (e) => {
    setHeadObject((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
      sBrandArr: [],
      sBrandPrnt: "",
      sBrandName: "",
      sBrandCategoryArr: [],
      sBrandCategoryPrnt: "",
      sBrandCategoryCode: "",
      sBrandCategoryName: "",
    }));
    setBrandCategoryData([]);
    if (e.target.value.toUpperCase() == "ALL") {
      setBrandData([]);
    } else if (e.target.value.toUpperCase() == "IS") {
      await GetWmsStockRepotBrand(setBrandData);
    }
  };
  const fBrand_MultiSelect = async (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sBrandArr: value,
      sBrandPrnt: value?.length <= 0 ? "" : currentPrnt,
      sBrandName: value?.length <= 0 ? "" : currentName,
    }));
    let xGroupStructureObj = {
      grp: value?.length <= 0 ? "" : currentPrnt,
    };
    await fWmsStockRepotBrandArr(xGroupStructureObj, setBrandCategoryData);
    fBrand_Focus();
  };

  const fBrand_Focus = (value) => {
    setHeadObject((obj) => ({
      ...obj,
      sBrandCategoryArr: [],
      sBrandCategoryPrnt: "",
      sBrandCategoryCode: "",
      sBrandCategoryName: "",
    }));
  };

  // const fBrandCategory = async (e) => {
  //   setHeadObject((obj) => ({
  //     ...obj,
  //     sBrandCategory: e.target.value,
  //     sBrandCategoryArr: [],
  //     sBrandCategoryPrnt: "",
  //     sBrandCategoryName: "",
  //   }));

  //   if (e.target.value.toUpperCase() == "ALL") {
  //     setBrandCategoryData([]);
  //   } else if (e.target.value.toUpperCase() == "IS") {
  //     let xGroupStructureObj2 = {
  //       grp: HeadObject.sBrandPrnt,
  //     };

  //     await fWmsStockRepotArr(xGroupStructureObj2, setBrandCategoryData);
  //   }
  // };

  const fBrandCategory_MultiSelect = (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sBrandCategoryArr: value,
      sBrandCategoryPrnt: value?.length <= 0 ? "" : currentPrnt,
      sBrandCategoryName: value?.length <= 0 ? "" : currentName,
    }));
  };

  //common_VendorListReport_GETROW
  const fMainSupplier = async (e) => {
    setHeadObject((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
      sMainSupplierArr: [],
      sMainSupplierPrnt: "",
      sMainSupplierName: "",
    }));
    if (e.target.value.toUpperCase() == "ALL") {
      setMainSupplierData([]);
    } else if (e.target.value.toUpperCase() == "IS") {
      await GetWmsStockRepotMainSupplier(setMainSupplierData);
    }
  };
  const fMainSupplier_MultiSelect = async (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sMainSupplierArr: value,
      sMainSupplierPrnt: value?.length <= 0 ? "" : currentPrnt,
      sMainSupplierName: value?.length <= 0 ? "" : currentName,
    }));
  };

  const fDate = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sDate: e.target.value,
      sFromDate: new Date(),
      sToDate: new Date(),
    }));
  };
  const fFromDate = (e) => {
    if (
      e?.$d == "Invalid Date" ||
      e?.$d == null ||
      e?.$d === undefined ||
      e?.$d === ""
    ) {
      setHeadObject((obj) => ({
        ...obj,
        sFromDate: "",
      }));
    } else {
      setHeadObject((obj) => ({
        ...obj,
        sFromDate: e?.$d,
      }));
    }
  };
  const fToDate = (e) => {
    if (
      e?.$d == "Invalid Date" ||
      e?.$d == null ||
      e?.$d === undefined ||
      e?.$d === ""
    ) {
      setHeadObject((obj) => ({
        ...obj,
        sToDate: "",
      }));
    } else {
      setHeadObject((obj) => ({
        ...obj,
        sToDate: e?.$d,
      }));
    }
  };

  const fPurchaseType = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sPurchaseType: e.target.value,
    }));
  };
  const fPoID = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sPoID: e.target.value,
    }));
  };
  const fCancel = (e) => {
    setHeadObject(HeadObjectInit);

    setMainGroupData([]);
    setSubGroupData([]);
    setCategoryData([]);
    setBrandData([]);
    setBrandCategoryData([]);
    setMainSupplierData([]);
  };

  //Item start
  const GridDataColumnsItemSearch = [
    { field: "id", headerName: "ID", width: 70, hide: true },
    { field: "ItmCd", headerName: "ItmCd", width: 90 },
    { field: "Name1", headerName: "Name1", width: 450 },
    { field: "NameFL", headerName: "NameFL", width: 90 },
    { field: "MainGrpName", headerName: "MainGrpName", width: 90 },
    { field: "SuppRefNo1", headerName: "SuppRefNo1", width: 90 },
    { field: "Model", headerName: "Model", width: 90 },
    { field: "BaseUnitName", headerName: "BaseUnitName", width: 90 },
    { field: "BarCode", headerName: "BarCode", width: 90 },
  ];

  const ItemSearchData = ["Any", "Code", "Barcode", "Name", "RefNo", "NameFL"];
  const [sGridSelectRowData, setGridSelectRowData] = useState([]);
  const [sItemToggleDropdown, setItemToggleDropdown] = useState(false);
  const fItem = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sItem: e.target.value,
      sItemName: "",
      sItemCode: "",
    }));
  };
  const fItemName = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sItemName: e.target.value,
    }));
  };

  const fItemSearchKey = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      let vItemSearchFull = await GetItemFullSearchArr(HeadObject.sItemName);

      if (vItemSearchFull.length > 0) {
        setHeadObject((obj) => ({
          ...obj,
          sItemCode: vItemSearchFull[0].ItmCd,
          sItemName: vItemSearchFull[0].Name2,
        }));
      } else {
        fItemToggleClick(e);
      }
    } else if (e.key === "Backspace") {
      setHeadObject((obj) => ({
        ...obj,
        sItemCode: "",
        sItemName: e.target.value,
      }));
    }
  };

  //GCItemSearch
  const fGCToggleItemOnRowClick = async (e) => {
    let vItemSearchFull = await GetItemFullSearchArr(e.row.ItmCd);
    if (vItemSearchFull.length > 0) {
      setHeadObject((obj) => ({
        ...obj,
        sItemCode: vItemSearchFull[0].ItmCd,
        sItemName: vItemSearchFull[0].Name2,
      }));
    } else {
      // document.getElementsByName("B_ItmName")[0]?.focus();
    }
    setItemToggleDropdown(false);
  };

  //GCItemSearch
  const fGCToggleItemOnCellKeyDown = async (newSelectionModel, e) => {
    if (e.key === "Enter") {
      fGCToggleItemOnRowClick(newSelectionModel);
    }
  };

  const [sItemSearchDropdownObj, setItemSearchDropdownObj] = useState({
    Type: "Any",
    Data: "",
  });

  const fOnChangeItem = (e) => {
    setItemSearchDropdownObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };

  const fOnKeyUpItem = async (e) => {
    if (e.key == "Enter" || e._reactName == "onClick") {
      // SEARCHITEM001_GETROW
      GetSearchItem(
        sItemSearchDropdownObj.Data,
        sItemSearchDropdownObj.Type,
        setGridSelectRowData
      );
    }
    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };

  const handleClick = useCallback(() => {
    if (sItemToggleDropdown) {
      setItemToggleDropdown(false);
      // setGC_Toggle_Head_BinName_ToggleDropDowm(false);
      setGridSelectRowData([]);
      setItemSearchDropdownObj({
        Type: "Any",
        Data: "",
      });
    } else {
      setItemToggleDropdown(true);
      // setGC_Toggle_Head_BinName_ToggleDropDowm(false);
      setTimeout(() => {
        document?.getElementsByName("Data")[0]?.focus();
      }, 100);
    }
  }, [sItemToggleDropdown]);

  const fItemToggleClick = (e) => {
    setGridSelectRowData([]);
    setItemSearchDropdownObj((obj) => ({
      ...obj,
      Data: HeadObject.sItemName,
    }));

    if (HeadObject.sItemName != "") {
      GetSearchItem(HeadObject.sItemName, "Any", setGridSelectRowData);
    }

    handleClick();
  };

  //Item End
  const vRdxuserInfo = useSelector((state) => state.login.value);
  const vRdxDBKernObj = useSelector((state) => state.SliceDB.value.DBKernObj);

  const GetReportsView = async () => {
    let xPurchaseTypeTitle =
      HeadObject.sPurchaseType == "LAST_5_COST"
        ? "Last 5 Cost"
        : "SELECTED_LOC"
        ? "Selected Loction"
        : "ALL_ITM_WITH_SELECTED_LOC"
        ? "All Items with Selected Location"
        : "";

    let urlPrint = vRdxDBKernObj.WEB_REPORT_BASE_URL?.Val;
    let sCurrentReport = "";
    let sReportTitle = "";
    const supplierName = HeadObject?.sMainSupplierArr
      .map((x) => x.Name1)
      .join(", ");
    const brandName = HeadObject?.sBrandArr.map((x) => x.Name1).join(", ");
    let ReportTitleObj = {
      Location: HeadObject.sLocationName,
      MainGroup: HeadObject.sMainGroupName,
      SubGroup: HeadObject.sSubGroupName,
      Group: HeadObject.sCategoryName,
      Supplier: supplierName,
      Brand: brandName,
      ItemName: HeadObject.sItemName,
      PurchaseType: xPurchaseTypeTitle,
      Buyer: HeadObject.sBuyerName,
      PoID: HeadObject.sPoID,
      DateBetween:
        "Between " +
        moment(HeadObject.sFromDate).format("DD-MM-YYYY") +
        " and " +
        moment(HeadObject.sToDate).format("DD-MM-YYYY"),
    };
    // String UserCd, String Date1, String Date2,
    //  String ItmCd, String Buyer, String MainGrp,
    //   String SubGrp, String Grp, String Brand,
    //   String MainSupplier, String PO_NDX,
    //   String LocCSV, String ReportType
    sReportTitle = ReportTitle(ReportTitleObj);

    const suplGrpData = HeadObject?.sMainSupplierArr
      .map((x) => x.AcCd)
      .join(",");
    const brandGrpData = HeadObject?.sBrandArr.map((x) => x.UID).join(",");
    let ReportUrlObj = {
      UserCd: vRdxuserInfo.UserID,
      Date1: moment(HeadObject.sFromDate).format("MM-DD-YYYY"),
      Date2: moment(HeadObject.sToDate).format("MM-DD-YYYY"),
      ItmCd: HeadObject.sItemCode,
      Buyer: HeadObject.sBuyerPrnt,
      MainGrp: HeadObject.sMainGroupPrnt,
      SubGrp: HeadObject.sSubGroupPrnt,
      Grp: HeadObject.sCategoryPrnt,
      Brand: brandGrpData,
      MainSupplier: suplGrpData,
      PO_NDX: HeadObject.sPoID,
      LocCSV: HeadObject.sLocationPrnt,
      ReportType: HeadObject.sPurchaseType,
    };
    console.log(ReportUrlObj);
    sCurrentReport = ReportUrl(ReportUrlObj);

    sCurrentReport = ReportRemoveSequenceChar(sCurrentReport);

    console.log(
      "sCurrentReport",
      urlPrint + "WMS/POCostCompare?" + sCurrentReport
    );
    setWebReportUrlModal(urlPrint + "WMS/POCostCompare?" + sCurrentReport);
    fWebReport();
  };

  const fPreview = async (e) => {
    let iValidationHead_Client = fValidationHead_Client(HeadObject);
    if (!iValidationHead_Client) return;

    await GetReportsView();
  };

  // CLICK ANY WHERE AND CLOSE IF TOGGLE IS CLOSED
  useEffect(() => {
    const handleClick = (event) => {
      if (sItemToggleDropdown) {
        const toggleElement = event.target.closest(".toggleSearch");
        if (!toggleElement) {
          setItemToggleDropdown(false);
        }
      }
    };
    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [sItemToggleDropdown]);

  //Modal fWebReportModal
  const [sWebReportModal, setWebReportModal] = useState(false);
  const [sWebReportUrlModal, setWebReportUrlModal] = useState("");
  const fWebReport = () => {
    setWebReportModal(true);
  };

  const fCloseWebReportModal = (e) => {
    setWebReportModal(false);
  };

  const fLoad = async () => {
    await GetLocation(setLocationData);
    await GetBuyer(setBuyerData);
  };

  useEffect(() => {
    fLoad();
  }, []);

  return (
    <div className="container-fluid">
      <div className="row">
        <div></div>
        <div className="col-12">
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 0 }}
            columnSpacing={{ xs: 0, sm: 0, md: 0 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className={vMediaQuery ? "py-4" : "py-4"}
          >
            <Grid item xs={12} sm={12} md={8}>
              <WmsHead
                fLocation_MultiSelect={fLocation_MultiSelect}
                sLocationData={sLocationData}
                fBuyer_MultiSelect={fBuyer_MultiSelect}
                sBuyerData={sBuyerData}
                fMainGroup_MultiSelect={fMainGroup_MultiSelect}
                sMainGroupData={sMainGroupData}
                fSubGroup_MultiSelect={fSubGroup_MultiSelect}
                sSubGroupData={sSubGroupData}
                fCategory_MultiSelect={fCategory_MultiSelect}
                sCategoryData={sCategoryData}
                fBrand_MultiSelect={fBrand_MultiSelect}
                sBrandData={sBrandData}
                fBrandCategory_MultiSelect={fBrandCategory_MultiSelect}
                sBrandCategoryData={sBrandCategoryData}
                fMainSupplier_MultiSelect={fMainSupplier_MultiSelect}
                sMainSupplierData={sMainSupplierData}
                sWebStockReportData={sWebStockReportData}
                sWebStockReportArr={sWebStockReportArr}
                HeadObject={HeadObject}
                setHeadObject={setHeadObject}
                fLocation={fLocation}
                fBuyer={fBuyer}
                fMainGroup={fMainGroup}
                fSubGroup={fSubGroup}
                fCategory={fCategory}
                fMainSupplier={fMainSupplier}
                fBrand={fBrand}
                fFromDate={fFromDate}
                fToDate={fToDate}
                fDate={fDate}
                fPurchaseType={fPurchaseType}
                fPoID={fPoID}
                sWebBetweenReportArr={sWebBetweenReportArr}
                // fBrandCategory={fBrandCategory}

                fItem={fItem}
                fItemName_onKeyUp={fItemSearchKey}
                fItemName={fItemName} //onchange main input
                xMediaQuery={vMediaQuery} //mobile screen
                xonClickbtn={fItemSearchKey} // onclick icon open div on main screen
                xrows={sGridSelectRowData} //Grid Row GCToggle Search from API
                xcolumns={GridDataColumnsItemSearch} //GCToggleSearch-Grid col GCToggle Search fron Action
                xRowCellClick={fGCToggleItemOnCellKeyDown} //GCToggleSearch-grid clic
                xRowClick={fGCToggleItemOnRowClick} //GCToggleSearch- grid click
                xToggle={sItemToggleDropdown} //GCToggleSearch-to show div using true/false (after xonClickbtn state value will be passed)
                xData={ItemSearchData} // GCToggleSearch-select-tag arr
                xOnChangeDropdownInput={fOnChangeItem} //GCToggleSearch-input search onchane DATA/TYPE
                xDropdownObj={sItemSearchDropdownObj} // GCToggleSearch-object DATA/TYPE
                xOnKeyUpDropdownInput={fOnKeyUpItem} //GCToggleSearch
              />
            </Grid>
          </Grid>
          <Grid
            container
            rowSpacing={{ xs: 1, sm: 0, md: 0 }}
            columnSpacing={{ xs: 1, sm: 0, md: 3 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className={
              vMediaQuery
                ? " justify-content-center text-center"
                : "py-2 justify-content-center text-center"
            }
          >
            <Grid item xs={6} sm={6} md={"auto"} className="text-center">
              <CmpButton
                xbtnName="Preview"
                xOnClick={fPreview}
                xVariant="contained"
                xDisabled={false}
                xSize="small"
                xId={""}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={"auto"} className="text-center">
              <CmpButton
                xbtnName="Cancel"
                xOnClick={fCancel}
                xVariant="contained"
                xDisabled={false}
                xSize="small"
                xId={""}
              />
            </Grid>
          </Grid>
        </div>
      </div>

      <GCWebReport
        xfCloseWebReportModal={fCloseWebReportModal}
        xWebReportUrlModal={sWebReportUrlModal}
        xTitle="Report"
        xWebReportModal={sWebReportModal}
      />
    </div>
  );
}
